import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';

export default function HelpContext(props){
      return (
      <span>
            {"If you have a hard time setting your prefernces, or just want to get some inspiration.\n\
            There are preset options of prefernces. From which you can start, and adjust them to fit your spcific prefernces"}
            
      </span>);
}
